import { CornerMarkerDot } from "../../core/CornerMarkerDot";

interface ColumnDividerProps {
  /** Hide the dot at the top of the divider — use on slots in non-first rows so the dot at the row-break boundary isn't drawn twice. */
  hideTopDot?: boolean;
  /** Hide the dot at the bottom of the divider — use on slots in non-last rows so the dot at the row-break boundary isn't drawn twice. */
  hideBottomDot?: boolean;
}

/**
 * Vertical 1px line rendered at the right edge of a slot, with optional
 * dots at the top and bottom. Place inside a `tw-relative` slot that lives
 * inside a horizontally-scrollable row — the divider scrolls with its slot
 * so it stays aligned with the card boundary at every viewport width.
 */
export function ColumnDivider({ hideTopDot = false, hideBottomDot = false }: ColumnDividerProps = {}) {
  return (
    <div className='tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-w-[1px] tw-z-10 tw-bg-black/5'>
      {!hideTopDot && <CornerMarkerDot backgroundColor='white' position='topCentered' />}
      {!hideBottomDot && <CornerMarkerDot backgroundColor='white' position='bottomCentered' />}
    </div>
  );
}
